
// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Customizer, { downloadCanvasToImage } from "./Customizer";
// import Canva from "./Canva";
// import { FaInfoCircle, FaVideo } from "react-icons/fa";
// import { MdSave, MdVerified } from "react-icons/md";
// import "../Styles/ThreeDLayout.css";
// import { get_glbFile, saveDesign } from "../Services/Operations/ProductAPI"; // Import save API
// import { IoIosSave } from "react-icons/io";
// import { X } from "lucide-react"; // Add this import for X icon
// import state from "./index.js";
// import modelConfig1 from "./modelConfig1.js";
// import { useSnapshot } from "valtio";
// import { useDispatch, useSelector } from "react-redux";
// import { resetModifiedGLB, setModifiedGLB } from "../Redux/Cart_System.js";
// import * as THREE from "three";
// import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter.js";

// const MODEL_PRIORITY_KEYS = [
//   "customize_file_4k",
//   "customize_file_hd",
//   "customize_file_high",
//   "customize_file_medium",
//   "customize_file",
// ];


// const enhanceGlbPayload = (files) => {
//   if (!Array.isArray(files)) {
//     return null;
//   }

//   return files.map((file) => {
//     if (!file || typeof file !== "object") {
//       return file;
//     }

//     const bestSource = MODEL_PRIORITY_KEYS.map((key) => file[key]).find(
//       Boolean
//     );

//     if (bestSource && bestSource !== file.customize_file) {
//       return {
//         ...file,
//         customize_file: bestSource,
//       };
//     }

//     return file;
//   });
// };

// const ThreeDSkeleton = () => (
//   <div className="threed-skeleton">
//     <div className="threed-skeleton__sidebar">
//       {Array.from({ length: 6 }).map((_, index) => (
//         <div
//           key={`skeleton-sidebar-${index}`}
//           className="threed-skeleton__line"
//         />
//       ))}
//     </div>
//     <div className="threed-skeleton__viewport">
//       <div className="threed-skeleton__model" />
//       <div className="threed-skeleton__hint" />
//       <div className="threed-skeleton__hint threed-skeleton__hint--small" />
//     </div>
//   </div>
// );

// const EmptyState = ({ onRetry }) => (
//   <div className="threed-empty">
//     <span className="threed-empty__emoji" role="img" aria-label="Target">
//       🎯
//     </span>
//     <h3>No 3D model available</h3>
//     <p>Please select a valid product to continue.</p>
//     {onRetry && (
//       <button type="button" className="threed-empty__retry" onClick={onRetry}>
//         Retry
//       </button>
//     )}
//   </div>
// );

// // Move deleteProduct function outside the component
// const deleteProduct = (productId, state, snap) => {
//   const productCount = Object.keys(snap.products).length;
  
//   // Prevent deleting if it's the only product
//   if (productCount <= 1) {
//     toast.error("Cannot delete the last product");
//     return;
//   }
  
//   // Show confirmation dialog
//   if (!window.confirm(`Are you sure you want to delete ${productId.replace('product', 'Product ')}?`)) {
//     return;
//   }
  
//   // If deleting the current product, switch to another one first
//   if (snap.currentProductId === productId) {
//     const productIds = Object.keys(snap.products);
//     const currentIndex = productIds.indexOf(productId);
//     const newCurrentId = currentIndex > 0 
//       ? productIds[currentIndex - 1] 
//       : productIds[currentIndex + 1];
    
//     state.currentProductId = newCurrentId;
//   }
  
//   // Delete the product
//   delete state.products[productId];
  
//   // Force update
//   state.updateTrigger = (state.updateTrigger || 0) + 1;
  
//   toast.success(`${productId.replace('product', 'Product ')} deleted successfully!`);
// };

// const BottomToolbar = ({ 
//   onInfo, 
//   onSave, 
//   onTutorial, 
//   onSaveDesign, 
//   onDuplicate,
//   onAddProduct,                         
//   products,
//   currentProductId,
//   onProductSelect,
//   onDeleteProduct 
// }) => {
//   const [isMobile, setIsMobile] = useState(() => window.innerWidth < 767);
  
//   return (
//     <div className="threed-toolbar">
//       {/* Product Tabs - Only show if there are multiple products */}
//       {products && Object.keys(products).length > 0 && (
//         <div className="product-tabs" style={{
//           position: 'absolute',
//           bottom: '79px',
//           left: '42%',
//           transform: 'translateX(-50%)',
//           display: 'flex',
//           gap: '8px',
//           padding: '8px',
//           background: 'white',
//           borderRadius: '4px',
//           boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//           zIndex: 1000,
//           flexWrap: 'wrap',
//           maxWidth: '90vw',
//           justifyContent: 'center'
//         }}>
//           {Object.entries(products).map(([id, product]) => (
//             <div key={id} style={{ position: 'relative', display: 'inline-block' }}>
//               <button
//                 type="button"
//                 onClick={() => onProductSelect(id)}
//                 style={{
//                   padding: '6px 12px',
//                   paddingRight: Object.keys(products).length > 1 ? '28px' : '12px',
//                   background: currentProductId === id ? '#155DE2' : '#f0f0f0',
//                   color: currentProductId === id ? 'white' : '#333',
//                   border: '1px solid #ddd',
//                   borderRadius: '4px',
//                   cursor: 'pointer',
//                   fontSize: '14px',
//                   transition: 'all 0.2s',
//                   minWidth: '90px',
//                   textAlign: 'center'
//                 }}
//               >
//                 {id.replace('product', 'Product ')}
//               </button>
              
//               {/* Delete Button - Only show if more than one product */}
//               {Object.keys(products).length > 1 && (
//                 <button
//                   type="button"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     onDeleteProduct(id);
//                   }}
//                   style={{
//                     position: 'absolute',
//                     top: '-6px',
//                     right: '-6px',
//                     width: '20px',
//                     height: '20px',
//                     padding: '0',
//                     background: currentProductId === id ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.1)',
//                     border: 'none',
//                     borderRadius: '50%',
//                     cursor: 'pointer',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     transition: 'all 0.2s',
//                     color: currentProductId === id ? 'white' : '#333',
//                     fontSize: '12px',
//                     fontWeight: 'bold',
//                     zIndex: 10
//                   }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.background = '#dc3545';
//                     e.currentTarget.style.color = 'white';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.background = currentProductId === id ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.1)';
//                     e.currentTarget.style.color = currentProductId === id ? 'white' : '#333';
//                   }}
//                   title={`Delete ${id.replace('product', 'Product ')}`}
//                 >
//                   <X size={12} />
//                 </button>
//               )}
//             </div>
//           ))}
          
//           {/* Add Product Button - Only creates duplicate */}
//           <button
//             type="button"
           
//             onClick={onDuplicate}
//             style={{
//               padding: '6px 12px',
//               background: '#28a745',
//               color: 'white',
//               border: 'none',
//               borderRadius: '4px',
//               cursor: 'pointer',
//               fontSize: '14px',
//               transition: 'all 0.2s',
//               display: 'flex',
//               alignItems: 'center',
//               gap: '4px'
//             }}
//           >
//             <span style={{ fontSize: '18px' }}>+</span>
//             Add Product
//           </button>
//         </div>
//       )}

//       <div
//         className="threed-toolbar__actions"
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           minWidth: isMobile ? "100%" : "",
//           paddingLeft: 0,
//         }}
//       >
//         <button
//           type="button"
//           onClick={onInfo}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "6px",
//             padding: "8px 12px",
//             border: "1px solid black",
//           }}
//         >
//           <FaInfoCircle aria-hidden="true" />
//           Infos
//         </button>
//         <button
//           type="button"
//           onClick={onSave}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "6px",
//             padding: "8px 12px",
//             border: "1px solid black",
//           }}
//         >
//           <MdSave aria-hidden="true" />
//           Share {!isMobile && " your design"}
//         </button>
//         <button
//           type="button"
//           onClick={onTutorial}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "6px",
//             padding: "8px 12px",
//             border: "1px solid black",
//           }}
//         >
//           <FaVideo aria-hidden="true" />
//           Tutorial
//         </button>
//         <button
//           type="button"
//           onClick={onSaveDesign}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "6px",
//             padding: "8px 12px",
//             border: "1px solid black",
//           }}
//         >
//           <IoIosSave aria-hidden="true" />
//           Save Design
//         </button>
//         {/* Duplicate button in toolbar - opens design section after duplication */}
//         <button
//           type="button"
//           // onClick={onDuplicate}
//            onClick={onAddProduct} 
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "6px",
//             padding: "8px 12px",
//             border: "1px solid black",
//           }}
//         >
//           <IoIosSave aria-hidden="true" />
//           Duplicate
//         </button>
//       </div>
//       <div className="threed-toolbar__promo" />
//     </div>
//   );
// };

// const DesignAssuranceBanner = ({ onClose }) => (
//   <div className="threed-assurance">
//     <div className="threed-assurance__content">
//       <MdVerified size={20} color="#0a0a0f" aria-hidden="true" />
//       <p>
//         <strong>Design-Check:&nbsp;</strong>
//         Our graphic designers check every design!
//         <br />
//         If we have any questions or comments, we'll get back to you in time.
//       </p>
//     </div>
//     <button
//       type="button"
//       className="threed-assurance__close"
//       onClick={onClose}
//       aria-label="Dismiss design assurance"
//     >
//       ×
//     </button>
//   </div>
// );

// const InfoModal = ({ onClose }) => (
//   <div className="threed-modal-backdrop" role="presentation" onClick={onClose}>
//     <div
//       className="threed-modal"
//       role="dialog"
//       aria-modal="true"
//       aria-label="About this product"
//       onClick={(event) => event.stopPropagation()}
//     >
//       <button
//         type="button"
//         className="threed-modal__close"
//         onClick={onClose}
//         aria-label="Close info modal"
//       >
//         ×
//       </button>
//       <div className="threed-modal__body">
//         <h2>About this product</h2>
//         <div className="threed-modal__grid">
//           <div className="threed-modal__image">
//             <img src="/asset/img/productss.png" alt="Product preview" />
//           </div>
//           <div className="threed-modal__details">
//             <h3>Game-Time Ready: Official Cricket Jersey</h3>
//             <p className="threed-modal__price">
//               $23/- &nbsp; $49/- &nbsp; you save $26/-
//             </p>
//             <p className="threed-modal__description">
//               Colours and colour combinations — take control of your football
//               shirt design with our wide selection! Choose from a curated
//               palette of 48 stunning standard colours, each paired with its
//               corresponding Pantone Matching System (PMS) number for precision.
//               Whether you&rsquo;re matching your team&rsquo;s exact shade or
//               creating something unique, we&rsquo;ve got you covered.
//               <br />
//               <br />
//               Don&rsquo;t see the colour you had in mind? Reach out to us by
//               email, and we&rsquo;ll bring your custom colour vision to life.
//               Your design, your colour. Let&rsquo;s make it happen! Perfect for
//               bulk order football jerseys, custom football T-shirts, and sports
//               clothing worldwide.
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// );

// const VideoModal = ({ onClose }) => (
//   <div className="threed-modal-backdrop" role="presentation" onClick={onClose}>
//     <div
//       className="threed-modal threed-modal--narrow"
//       role="dialog"
//       aria-modal="true"
//       aria-label="Configurator tutorial"
//       onClick={(event) => event.stopPropagation()}
//     >
//       <button
//         type="button"
//         className="threed-modal__close"
//         onClick={onClose}
//         aria-label="Close tutorial modal"
//       >
//         ×
//       </button>
//       <div className="threed-modal__body">
//         <h2>Step-by-step through the configurator</h2>
//         <img
//           className="threed-video-modal__image"
//           src="/asset/img/modalss.png"
//           alt="Configurator tutorial"
//         />
//       </div>
//     </div>
//   </div>
// );

// const SaveModal = ({ onClose, onConfirm, loading }) => (
//   <div className="threed-modal-backdrop" role="presentation" onClick={onClose}>
//     <div
//       className="threed-modal"
//       role="dialog"
//       aria-modal="true"
//       aria-label="Save Design"
//       onClick={(event) => event.stopPropagation()}
//       style={{ width: "400px" }}
//     >
//       <button
//         type="button"
//         className="threed-modal__close"
//         onClick={onClose}
//         aria-label="Close save modal"
//       >
//         ×
//       </button>
//       <div className="threed-modal__body">
//         <h2>Save Design</h2>
//         <p>Are you sure you want to save this design?</p>
//         <div className="modal-buttons" style={{ marginTop: "20px" }}>
//           <button className="ok-button" onClick={onConfirm} disabled={loading}>
//             {loading ? "Saving..." : "Save"}
//           </button>
//           <button
//             className="cancel-button"
//             onClick={onClose}
//             disabled={loading}
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     </div>
//   </div>
// );

// const ThreeD = () => {
//   const location = useLocation();
//   const snap = useSnapshot(state);
//   const navigate = useNavigate();
//   const defaultMenuSlug = "men";
//   const defaultSubcategorySlug = "men-cricket-jersey";
//   const gltfRef = useRef(null);

//   const modifiedGLB = useSelector((state) => state.cart.modifiedGLB);
//   const { tokenDetails } = useSelector((state) => state.user);
//   const { glbId } = useSelector((state) => state.cart);
//   const dispatch = useDispatch();

//   const stateMenuSlug = location.state?.menuSlug;
//   const stateSubcategorySlug = location.state?.subcategorySlug;
//   const stateGlbFile = location.state?.glbFile;
//   const stateSubcategoryId = location.state?.subcategoryId;
//   const draftData = location.state?.draftData;
//   const restoreData = location.state?.restoreData;

//   const [menuSlug, setMenuSlug] = useState(stateMenuSlug || defaultMenuSlug);
//   const [subcategorySlug, setSubcategorySlug] = useState(
//     stateSubcategorySlug || defaultSubcategorySlug
//   );
//   const [loadedGlbFile, setLoadedGlbFile] = useState(
//     () => enhanceGlbPayload(stateGlbFile) || null
//   );
//   const [isLoading, setIsLoading] = useState(() => !stateGlbFile);
//   const [isMobile, setIsMobile] = useState(() => window.innerWidth < 567);
//   const [popupModal, setPopupModal] = useState(true);
//   const [infoModal, setInfoModal] = useState(false);
//   const [vdoModal, setVdoModal] = useState(false);
//   const [saveModal, setSaveModal] = useState(false);
//   const [saveLoading, setSaveLoading] = useState(false);

//   // Add this state to track if we're restoring a draft
//   const [isRestoringDraft, setIsRestoringDraft] = useState(false);

//   const [isEditingDraft, setIsEditingDraft] = useState(false);

//   const handleProductSelect = useCallback((productId) => {
//     state.currentProductId = productId;
//   }, []);

//   // Handle delete product
//   const handleDeleteProduct = useCallback((productId) => {
//     deleteProduct(productId, state, snap);
//   }, [snap]);

//   const [activeSection, setActiveSection] = useState(null);
//   const [activeSubSection, setActiveSubSection] = useState(null);
  
//   // Function to open Design section
//   const openDesignSection = useCallback(() => {
//     setActiveSection("design");
//     setActiveSubSection("category");
    
//     // Scroll to Customizer section if on mobile
//     if (window.innerWidth < 567) {
//       const customizerElement = document.querySelector('.threed-customizer');
//       if (customizerElement) {
//         customizerElement.scrollIntoView({ behavior: 'smooth' });
//       }
//     }
//   }, []);

//   // Update the useEffect that restores draft settings
//   useEffect(() => {
//     if (restoreData?.settings) {
//       console.log("Restoring draft data:", restoreData);
//       setIsEditingDraft(true);
//       restoreDraftSettings(restoreData);
//     }
//   }, [restoreData]);

//   // Add this effect to restore draft data
//   useEffect(() => {
//     if (restoreData?.settings) {
//       console.log("Restoring draft data:", restoreData);
//       restoreDraftSettings(restoreData);
//     }
//   }, [restoreData]);

//   const restoreDraftSettings = useCallback(
//     (draftData) => {
//       try {
//         setIsRestoringDraft(true);

//         // Parse settings if it's a string
//         const settings =
//           typeof draftData.settings === "string"
//             ? JSON.parse(draftData.settings)
//             : draftData.settings;

//         console.log("Parsed settings for restoration:", settings);

//         // Get current product reference
//         const currentProduct = state.products[state.currentProductId];
        
//         if (!currentProduct) {
//           console.error("No current product found for restoration");
//           return;
//         }

//         // Restore all state values to current product
//         if (settings.frontText) currentProduct.frontText = settings.frontText;
//         if (settings.backText) currentProduct.backText = settings.backText;
//         if (settings.frontNumber) currentProduct.frontNumber = settings.frontNumber;
//         if (settings.backNumber) currentProduct.backNumber = settings.backNumber;

//         // Restore colors
//         if (settings.Colors) {
//           currentProduct.partColors = settings.Colors;
//         }

//         // Restore text and number colors
//         if (settings.textColors) {
//           currentProduct.textColors = settings.textColors;
//         }

//         if (settings.numberColors) {
//           currentProduct.numberColors = settings.numberColors;
//         }

//         // Restore gradient colors
//         if (settings.gradientColors) {
//           currentProduct.gradientColors = settings.gradientColors;
//         }

//         // Restore fonts
//         if (settings.textFonts) {
//           currentProduct.textFonts = settings.textFonts;
//         }

//         if (settings.numberFonts) {
//           currentProduct.numberFonts = settings.numberFonts;
//         }

//         if (settings.imagesPattern) {
//           currentProduct.imagesPattern = settings.imagesPattern;
//         }

//         // Restore fonts
//         if (settings.patternColors) {
//           currentProduct.patternColors = settings.patternColors;
//         }

//         if (settings.numberFonts) {
//           currentProduct.selectedFonts = settings.selectedFonts;
//         }

//         if (settings.selectedPattern) {
//           currentProduct.selectedPattern = settings.selectedPattern;
//         }

//         // Set the correct model key based on menuSlug and subcategorySlug
//         if (menuSlug && subcategorySlug) {
//           const key = `${menuSlug}${subcategorySlug}`.replace(/-/g, "");
//           if (modelConfig1[key]) {
//             currentProduct.newKey = key;
//           }
//         }

//         // Trigger a re-render
//         state.updateTrigger = (state.updateTrigger || 0) + 1;

//         console.log("Draft restoration complete");

//         // Show success message
//         setTimeout(() => {
//           setIsRestoringDraft(false);
//         }, 500);
//       } catch (error) {
//         console.error("Error restoring draft:", error);
//         setIsRestoringDraft(false);
//       }
//     },
//     [menuSlug, subcategorySlug]
//   );

//   useEffect(() => {
//     if (stateMenuSlug && stateMenuSlug !== menuSlug) {
//       setMenuSlug(stateMenuSlug);
//     }
//   }, [stateMenuSlug, menuSlug]);

//   useEffect(() => {
//     if (stateSubcategorySlug && stateSubcategorySlug !== subcategorySlug) {
//       setSubcategorySlug(stateSubcategorySlug);
//     }
//   }, [stateSubcategorySlug, subcategorySlug]);

//   useEffect(() => {
//     if (!stateGlbFile) {
//       return;
//     }
//     setLoadedGlbFile(enhanceGlbPayload(stateGlbFile));
//     setIsLoading(false);
//   }, [stateGlbFile]);

//   useEffect(() => {
//     let isMounted = true;

//     const fetchGlb = async () => {
//       if (loadedGlbFile) {
//         return;
//       }

//       setIsLoading(true);

//       try {
//         const formData = new FormData();
//         formData.append("subcategoryId", stateSubcategoryId || 22);

//         const result = await get_glbFile(formData);

//         if (!isMounted) {
//           return;
//         }

//         if (
//           !result?.success ||
//           !Array.isArray(result?.data) ||
//           result.data.length === 0
//         ) {
//           toast.error("Failed to fetch 3D model. Please try again.");
//           setLoadedGlbFile(null);
//           return;
//         }

//         setLoadedGlbFile(enhanceGlbPayload(result.data));
//       } catch (error) {
//         if (!isMounted) {
//           return;
//         }
//         console.error("Error fetching GLB:", error);
//         toast.error("Something went wrong while loading the 3D model.");
//         setLoadedGlbFile(null);
//       } finally {
//         if (isMounted) {
//           setIsLoading(false);
//         }
//       }
//     };

//     fetchGlb();

//     return () => {
//       isMounted = false;
//     };
//   }, [loadedGlbFile, stateSubcategoryId]);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 567);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const handleRetryFetch = useCallback(() => {
//     setLoadedGlbFile(null);
//     setIsLoading(false);
//   }, []);

//   const handleInfoClick = useCallback(() => {
//     setInfoModal(true);
//     setVdoModal(false);
//   }, []);

//   const handleSaveClick = useCallback(() => {
//     downloadCanvasToImage();
//   }, []);

//   const handleTutorialClick = useCallback(() => {
//     setVdoModal(true);
//     setInfoModal(false);
//   }, []);

//   const handleSaveDesignClick = useCallback(() => {
//     if (!tokenDetails) {
//       toast.error("Please login or Signup to save designs");
//       return;
//     }
//     setSaveModal(true);
//   }, [tokenDetails]);



//   const confirmSaveDesign = useCallback(async () => {
//     try {
//       setSaveLoading(true);

//       // Get current product from state
//       const currentProduct = snap.products[snap.currentProductId];
      
//       if (!currentProduct) {
//         toast.error("No active product found");
//         setSaveLoading(false);
//         return;
//       }

//       console.log("currentProduct.partColors : ", currentProduct.partColors);
//       console.log("currentProduct.textColors : ", currentProduct.textColors);
//       console.log("currentProduct.numberColors : ", currentProduct.numberColors);
//       console.log("currentProduct.gradientColors : ", currentProduct.gradientColors);
//       console.log("currentProduct.frontText : ", currentProduct.frontText);
//       console.log("currentProduct.backText : ", currentProduct.backText);
//       console.log("currentProduct.frontNumber : ", currentProduct.frontNumber);
//       console.log("currentProduct.backNumber : ", currentProduct.backNumber);

//       // Get PNG snapshot
//       const canvas = document.querySelector("canvas");
//       if (!canvas) {
//         toast.error("Canvas not found");
//         setSaveLoading(false);
//         return;
//       }
//       const pngDataUrl = canvas.toDataURL("image/png");

//       // Get model settings
//       const newKey = currentProduct.newKey;
//       const imagesPattern = currentProduct.imagesPattern;
//       const modelSettings = modelConfig1[newKey];

//       let updatedSettings = {};
//       if (modelSettings) {
//         updatedSettings = {
//           ...modelSettings,
//           frontText: currentProduct.frontText,
//           backText: currentProduct.backText,
//           frontNumber: currentProduct.frontNumber,
//           backNumber: currentProduct.backNumber,
//           frontLogo: currentProduct.frontLogo,
//           backLogo: currentProduct.backLogo,
//           Colors: currentProduct.partColors,
//           textFonts: currentProduct.textFonts,
//           numberFonts: currentProduct.numberFonts,
//           textColors: currentProduct.textColors,
//           numberColors: currentProduct.numberColors,
//           gradientColors: currentProduct.gradientColors,
//           imagesPattern: currentProduct.imagesPattern,
//           patternColors: currentProduct.patternColors,
//           selectedFonts: currentProduct.selectedFonts,
//           selectedPattern: currentProduct.selectedPattern,
//         };
//       }

//       // Convert pattern images to files
//       const imageArray = Object.entries(imagesPattern).map(
//         ([position, pattern]) => {
//           const base64 = pattern.image;
//           const byteString = atob(base64.split(",")[1]);
//           const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];

//           const ab = new ArrayBuffer(byteString.length);
//           const ia = new Uint8Array(ab);
//           for (let i = 0; i < byteString.length; i++) {
//             ia[i] = byteString.charCodeAt(i);
//           }

//           const blob = new Blob([ab], { type: mimeString });
//           const file = new File([blob], `${position}_pattern.png`, {
//             type: mimeString,
//           });

//           return { position, file };
//         }
//       );

//       const formData = new FormData();

//       formData.append(
//         "cart",
//         JSON.stringify({
//           glb: [
//             {
//               glb_id: glbId,
//               settings: updatedSettings,
//               size_id: 1,
//               image: pngDataUrl,
//               menuSlug: menuSlug,
//               subcategorySlug: subcategorySlug,
//               productId: snap.currentProductId, // Save which product this is
//             },
//           ],
//         })
//       );

//       const cartData = imageArray.map(({ position }) => ({ position }));
//       formData.append("cartData", JSON.stringify(cartData));
//       imageArray.forEach(({ file }, index) => {
//         formData.append(`cartImage[${index}]`, file);
//       });

//       // Call save API
//       const response = await saveDesign(formData, tokenDetails);
//       console.log("response : ", response);
//       if (response.data.success) {
//         toast.success(response.data.message);
//         setSaveModal(false);
//         navigate("/profile");
//       } else {
//         toast.error(response.message || "Failed to save design");
//       }
//     } catch (error) {
//       console.error("Save design error:", error);
//       toast.error("An error occurred while saving the design");
//     } finally {
//       setSaveLoading(false);
//     }
//   }, [tokenDetails, glbId, menuSlug, subcategorySlug, snap]);

  


//   const duplicateCurrentProduct = useCallback(() => {
//     // Get current product ID
//     const currentProductId = snap.currentProductId || 'product1';
    
//     // Get all product IDs
//     const productIds = Object.keys(snap.products || {});
    
//     // Find the next available ID
//     const lastId = productIds.length > 0
//       ? Math.max(...productIds.map((id) => parseInt(id.replace("product", ""))))
//       : 0;
//     const newProductId = `product${lastId + 1}`;
    
//     console.log(`Duplicating from ${currentProductId} to ${newProductId}`);
    
//     // Get the source product
//     const sourceProduct = snap.products[currentProductId];
//     console.log("Source product data:", sourceProduct);
    
//     if (sourceProduct) {
//       // Deep clone with all properties
//       const clonedProduct = {
//         id: lastId + 1,
//         frontText: sourceProduct.frontText || '',
//         backText: sourceProduct.backText || '',
//         frontNumber: sourceProduct.frontNumber || '',
//         backNumber: sourceProduct.backNumber || '',
//         frontLogo: sourceProduct.frontLogo || null,
//         backLogo: sourceProduct.backLogo || null,
//         partColors: { ...(sourceProduct.partColors || {}) },
//         textColors: { ...(sourceProduct.textColors || {}) },
//         numberColors: { ...(sourceProduct.numberColors || {}) },
//         gradientColors: { ...(sourceProduct.gradientColors || {}) },
//         textFonts: { ...(sourceProduct.textFonts || {}) },
//         numberFonts: { ...(sourceProduct.numberFonts || {}) },
//         imagesPattern: { ...(sourceProduct.imagesPattern || {}) },
//         patternColors: { ...(sourceProduct.patternColors || {}) },
//         selectedFonts: sourceProduct.selectedFonts || "Arial",
//         selectedPattern: { ...(sourceProduct.selectedPattern || {}) },
//         svg: sourceProduct.svg || null,
//         modelName: sourceProduct.modelName || '',
//         viewSide: sourceProduct.viewSide || "front",
//         isActive: true,
//       };
      
//       console.log("Cloned product data:", clonedProduct);
      
//       // Update state with the new product
//       state.products[newProductId] = clonedProduct;
//       state.currentProductId = newProductId;
      
//       toast.success(`Product ${lastId + 1} created with same customizations!`);
      
//       // Force update to show the new product
//       state.updateTrigger = (state.updateTrigger || 0) + 1;
//     } else {
//       console.error("Source product not found for duplication");
//       toast.error("Failed to duplicate product");
//     }
//   }, [snap.products, snap.currentProductId, state]);

//     const duplicateCurrentProduct1 = useCallback(() => {
//     // Get current product ID
//     const currentProductId = snap.currentProductId || 'product1';
    
//     // Get all product IDs
//     const productIds = Object.keys(snap.products || {});
    
//     // Find the next available ID
//     const lastId = productIds.length > 0
//       ? Math.max(...productIds.map((id) => parseInt(id.replace("product", ""))))
//       : 0;
//     const newProductId = `product${lastId + 1}`;
    
//     console.log(`Duplicating from ${currentProductId} to ${newProductId}`);
    
//     // Get the source product
//     const sourceProduct = snap.products[currentProductId];
//     console.log("Source product data:", sourceProduct);
    
//     if (sourceProduct) {
//       // Deep clone with all properties
//       const clonedProduct = {
//         id: lastId + 1,
//         frontText: '',
//         backText: '',
//         frontNumber: '',
//         backNumber: '',
//         frontLogo: null,
//         backLogo: null,
//         partColors:  {} ,
//         textColors: {},
//         numberColors: {},
//         gradientColors: {},
//         textFonts: {},
//         numberFonts: {},
//         imagesPattern: {},
//         patternColors: {},
//         selectedFonts: "Arial",
//         selectedPattern: {},
//         svg: null,
//         modelName: '',
//         viewSide: "front",
//         isActive: true,
//       };
      
//       console.log("Cloned product data:", clonedProduct);
      
//       // Update state with the new product
//       state.products[newProductId] = clonedProduct;
//       state.currentProductId = newProductId;
      
//       // toast.success(`Product ${lastId + 1} created with same customizations!`);
      
//       // Force update to show the new product
//       state.updateTrigger = (state.updateTrigger || 0) + 1;
//     } else {
//       console.error("Source product not found for duplication");
//       toast.error("Failed to duplicate product");
//     }
//   }, [snap.products, snap.currentProductId, state]);

// const handleAddProduct = useCallback(() => {
//     // Just duplicate the product without opening design section
//     duplicateCurrentProduct();
//   }, [duplicateCurrentProduct]);
  
//   const handleDuplicateAndDesign = useCallback(() => {
//     // Duplicate and open design section
//      duplicateCurrentProduct1();
//     openDesignSection();
//   }, [duplicateCurrentProduct, openDesignSection]);
  
//   const normalizedGlbFile = useMemo(
//     () => (Array.isArray(loadedGlbFile) ? loadedGlbFile : []),
//     [loadedGlbFile]
//   );

//   if (isLoading) {
//     return <ThreeDSkeleton />;
//   }

//   const hasGlbData = normalizedGlbFile.length > 0;

//   if (!hasGlbData) {
//     return <EmptyState onRetry={handleRetryFetch} />;
//   }

  

//   return (
//     <div className="threed-page">
//       <div className="threed-customizer">
//         <Customizer glbFile={normalizedGlbFile}  activeSection={activeSection}
//           activeSubSection={activeSubSection}
//           onSectionClose={() => {
//             setActiveSection(null);
//             setActiveSubSection(null);
//           }}/>
//       </div>
//       <div className="threed-canvas">
//         <Canva
//           menuSlug={menuSlug}
//           subcategorySlug={subcategorySlug}
//           isEditingDraft={isEditingDraft}
//         />
//       </div>

//      <BottomToolbar
//         onInfo={handleInfoClick}
//         onSave={handleSaveClick}
//         onTutorial={handleTutorialClick}
//         onSaveDesign={handleSaveDesignClick}
//         onDuplicate={handleDuplicateAndDesign} // Duplicate & open design
//         onAddProduct={handleAddProduct} // Just add product
//         products={snap.products}
//         currentProductId={snap.currentProductId}
//         onProductSelect={handleProductSelect}
//         onDeleteProduct={handleDeleteProduct}
//       />

//       {!isMobile && popupModal && (
//         <DesignAssuranceBanner onClose={() => setPopupModal(false)} />
//       )}

//       {infoModal && !vdoModal && (
//         <InfoModal onClose={() => setInfoModal(false)} />
//       )}

//       {vdoModal && <VideoModal onClose={() => setVdoModal(false)} />}

//       {saveModal && (
//         <SaveModal
//           onClose={() => setSaveModal(false)}
//           onConfirm={confirmSaveDesign}
//           loading={saveLoading}
//         />
//       )}
//     </div>
//   );
// };

// export default ThreeD;

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Customizer, { downloadCanvasToImage } from "./Customizer";
import Canva from "./Canva";
import { FaInfoCircle, FaVideo, FaUndo, FaRedo } from "react-icons/fa";
import { MdSave, MdVerified } from "react-icons/md";
import "../Styles/ThreeDLayout.css";
import { get_glbFile, saveDesign } from "../Services/Operations/ProductAPI";
import { IoIosSave } from "react-icons/io";
import { X } from "lucide-react";
import state from "./index.js";
import modelConfig1 from "./modelConfig1.js";
import { useSnapshot } from "valtio";
import { useDispatch, useSelector } from "react-redux";
import { resetModifiedGLB, setModifiedGLB } from "../Redux/Cart_System.js";

const MODEL_PRIORITY_KEYS = [
  "customize_file_4k",
  "customize_file_hd",
  "customize_file_high",
  "customize_file_medium",
  "customize_file",
];

// ==================== UNDO/REDO HISTORY MANAGER ====================
// ==================== UNDO/REDO HISTORY MANAGER ====================
class HistoryManager {
  constructor(productId) {
    this.productId = productId;
    this.history = [];
    this.currentIndex = -1;
    this.maxHistory = 50;
    this.debounceTimer = null;
  }

  // Enhanced deepClone that handles Proxy objects and complex data
  deepClone(obj) {
    // Handle null/undefined
    if (obj === null || obj === undefined) return obj;
    
    // Handle Proxy objects (from valtio) - extract the actual data
    if (typeof obj === 'object' && obj[Symbol.for('valtio@proxy')]) {
      // Get the actual target object from proxy
      const target = this.getProxyTarget(obj);
      return this.deepClone(target);
    }
    
    // Handle primitive types
    if (typeof obj !== 'object') return obj;
    
    // Handle Date
    if (obj instanceof Date) return new Date(obj.getTime());
    
    // Handle Array
    if (Array.isArray(obj)) return obj.map(item => this.deepClone(item));
    
    // Handle Object
    const cloned = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        cloned[key] = this.deepClone(obj[key]);
      }
    }
    return cloned;
  }

  // Helper to get target from Proxy
  getProxyTarget(proxy) {
    try {
      // Try to get the actual target from valtio proxy
      if (proxy[Symbol.for('valtio@proxy')]) {
        return JSON.parse(JSON.stringify(proxy));
      }
    } catch (e) {
      console.warn("Could not extract proxy target:", e);
    }
    
    // Fallback: try to extract data
    try {
      const data = {};
      for (const key in proxy) {
        if (key !== 'toJSON' && typeof proxy[key] !== 'function') {
          data[key] = proxy[key];
        }
      }
      return data;
    } catch (e) {
      console.error("Failed to extract proxy data:", e);
      return {};
    }
  }

  // Create a complete snapshot with proper proxy handling
  createCompleteSnapshot(state) {
    // First, extract all data from proxy
    const extractedState = this.deepClone(state);
    
    // Ensure all image patterns are properly handled
    if (extractedState.imagesPattern) {
      Object.keys(extractedState.imagesPattern).forEach(key => {
        if (extractedState.imagesPattern[key]?.image) {
          // Ensure base64 image data is properly preserved
          extractedState.imagesPattern[key] = {
            ...extractedState.imagesPattern[key],
            image: String(extractedState.imagesPattern[key].image)
          };
        }
      });
    }
    
    return {
      ...extractedState,
      timestamp: Date.now()
    };
  }

  // Apply snapshot to product state - fixed to properly update valtio state
  applySnapshot(snapshot, targetState, stateProxy) {
    if (!snapshot || !targetState) return;
    
    // First, clear existing state
    Object.keys(targetState).forEach(key => {
      if (key !== 'id' && key !== 'isActive') {
        delete targetState[key];
      }
    });
    
    // Apply all properties from snapshot to target state
    Object.keys(snapshot).forEach(key => {
      if (key !== 'timestamp' && key !== 'id') {
        targetState[key] = this.deepClone(snapshot[key]);
      }
    });
    
    // Force valtio update
    if (stateProxy) {
      stateProxy.updateTrigger = (stateProxy.updateTrigger || 0) + 1;
    }
  }

  // Save with debouncing to prevent too many saves
  push(state, debounceMs = 300) {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    
    this.debounceTimer = setTimeout(() => {
      this.history = this.history.slice(0, this.currentIndex + 1);
      
      // Create a complete snapshot
      const snapshot = this.createCompleteSnapshot(state);
      
      this.history.push(snapshot);
      this.currentIndex++;
      
      if (this.history.length > this.maxHistory) {
        this.history.shift();
        this.currentIndex--;
      }
      
      console.log("History saved. Total:", this.history.length, "Current index:", this.currentIndex);
    }, debounceMs);
  }

  // Rest of the methods remain the same...
  undo() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      const snapshot = this.deepClone(this.history[this.currentIndex]);
      console.log("Undo to index:", this.currentIndex);
      return snapshot;
    }
    return null;
  }

  redo() {
    if (this.currentIndex < this.history.length - 1) {
      this.currentIndex++;
      const snapshot = this.deepClone(this.history[this.currentIndex]);
      console.log("Redo to index:", this.currentIndex);
      return snapshot;
    }
    return null;
  }

  canUndo() {
    return this.currentIndex > 0;
  }

  canRedo() {
    return this.currentIndex < this.history.length - 1;
  }

  getStatus() {
    return {
      canUndo: this.canUndo(),
      canRedo: this.canRedo(),
      currentIndex: this.currentIndex,
      total: this.history.length
    };
  }

  clear() {
    this.history = [];
    this.currentIndex = -1;
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }
}

const enhanceGlbPayload = (files) => {
  if (!Array.isArray(files)) {
    return null;
  }

  return files.map((file) => {
    if (!file || typeof file !== "object") {
      return file;
    }

    const bestSource = MODEL_PRIORITY_KEYS.map((key) => file[key]).find(
      Boolean
    );

    if (bestSource && bestSource !== file.customize_file) {
      return {
        ...file,
        customize_file: bestSource,
      };
    }

    return file;
  });
};

const ThreeDSkeleton = () => (
  <div className="threed-skeleton">
    <div className="threed-skeleton__sidebar">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={`skeleton-sidebar-${index}`}
          className="threed-skeleton__line"
        />
      ))}
    </div>
    <div className="threed-skeleton__viewport">
      <div className="threed-skeleton__model" />
      <div className="threed-skeleton__hint" />
      <div className="threed-skeleton__hint threed-skeleton__hint--small" />
    </div>
  </div>
);

const EmptyState = ({ onRetry }) => (
  <div className="threed-empty">
    <span className="threed-empty__emoji" role="img" aria-label="Target">
      🎯
    </span>
    <h3>No 3D model available</h3>
    <p>Please select a valid product to continue.</p>
    {onRetry && (
      <button type="button" className="threed-empty__retry" onClick={onRetry}>
        Retry
      </button>
    )}
  </div>
);

// Move deleteProduct function outside the component
const deleteProduct = (productId, state, snap) => {
  const productCount = Object.keys(snap.products).length;
  
  // Prevent deleting if it's the only product
  if (productCount <= 1) {
    toast.error("Cannot delete the last product");
    return;
  }
  
  // Show confirmation dialog
  if (!window.confirm(`Are you sure you want to delete ${productId.replace('product', 'Product ')}?`)) {
    return;
  }
  
  // If deleting the current product, switch to another one first
  if (snap.currentProductId === productId) {
    const productIds = Object.keys(snap.products);
    const currentIndex = productIds.indexOf(productId);
    const newCurrentId = currentIndex > 0 
      ? productIds[currentIndex - 1] 
      : productIds[currentIndex + 1];
    
    state.currentProductId = newCurrentId;
  }
  
  // Delete the product
  delete state.products[productId];
  
  // Force update
  state.updateTrigger = (state.updateTrigger || 0) + 1;
  
  toast.success(`${productId.replace('product', 'Product ')} deleted successfully!`);
};

const BottomToolbar = ({ 
  onInfo, 
  onSave, 
  onTutorial, 
  onSaveDesign, 
  onDuplicate,
  onAddProduct,                         
  products,
  currentProductId,
  onProductSelect,
  onDeleteProduct,
  onUndo,
  onRedo,
  canUndo,
  canRedo 
}) => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 767);
  
  return (
    <div className="threed-toolbar">
      {/* Product Tabs - Only show if there are multiple products */}
      {products && Object.keys(products).length > 0 && (
        <div className="product-tabs" style={{
          // position: 'absolute',
          // bottom: '79px',
          // left: '42%',
          // transform: 'translateX(-50%)',
          // display: 'flex',
          // gap: '8px',
          // padding: '8px',
          // background: 'white',
          // borderRadius: '4px',
          // boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          // zIndex: 1000,
          // flexWrap: 'wrap',
          // maxWidth: '90vw',
          // justifyContent: 'center'
        }}>
          {Object.entries(products).map(([id, product]) => (
            <div key={id} style={{ position: 'relative', display: 'inline-block' }}>
              <button
                type="button"
                onClick={() => onProductSelect(id)}
                style={{
                  padding: '6px 12px',
                  paddingRight: Object.keys(products).length > 1 ? '28px' : '12px',
                  background: currentProductId === id ? '#155DE2' : '#f0f0f0',
                  color: currentProductId === id ? 'white' : '#333',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  transition: 'all 0.2s',
                  minWidth: '90px',
                  textAlign: 'center'
                }}
              >
                {id.replace('product', 'Product ')}
              </button>
              
              {/* Delete Button - Only show if more than one product */}
              {Object.keys(products).length > 1 && (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteProduct(id);
                  }}
                  style={{
                    position: 'absolute',
                    top: '-6px',
                    right: '-6px',
                    width: '20px',
                    height: '20px',
                    padding: '0',
                    background: currentProductId === id ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.1)',
                    border: 'none',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s',
                    color: currentProductId === id ? 'white' : '#333',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    zIndex: 10
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#dc3545';
                    e.currentTarget.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = currentProductId === id ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.1)';
                    e.currentTarget.style.color = currentProductId === id ? 'white' : '#333';
                  }}
                  title={`Delete ${id.replace('product', 'Product ')}`}
                >
                  <X size={12} />
                </button>
              )}
            </div>
          ))}
          
          {/* Add Product Button - Only creates duplicate */}
          <button
            type="button"
            onClick={onDuplicate}
            style={{
              padding: '6px 12px',
              background: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            <span style={{ fontSize: '18px' }}>+</span>
            Add Product
          </button>
        </div>
      )}

      <div
        className="threed-toolbar__actions"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          minWidth: isMobile ? "100%" : "",
          paddingLeft: 0,
        }}
      >
        {/* Undo/Redo Buttons */}
        <div style={{ display: "flex", gap: "9px",border: "1px solid black",padding: "12px 12px", }}>
          <button
            type="button"
            onClick={onUndo}
            disabled={!canUndo}
            style={{
              display: "flex",
              alignItems: "center",
            
              background: canUndo ? "#fff" : "#f5f5f5",
              color: canUndo ? "#000" : "#999",
              cursor: canUndo ? "pointer" : "not-allowed",
            }}
            title={canUndo ? "Undo (Ctrl+Z)" : "Nothing to undo"}
          >
            <FaUndo aria-hidden="true" />
            {/* Undo */}
          </button>
          <button
            type="button"
            onClick={onRedo}
            disabled={!canRedo}
            style={{
              display: "flex",
              alignItems: "center",
              
              background: canRedo ? "#fff" : "#f5f5f5",
              color: canRedo ? "#000" : "#999",
              cursor: canRedo ? "pointer" : "not-allowed",
            }}
            title={canRedo ? "Redo (Ctrl+Y)" : "Nothing to redo"}
          >
            <FaRedo aria-hidden="true" />
            {/* Redo */}
          </button>
        </div>

        <button
          type="button"
          onClick={onInfo}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 12px",
            border: "1px solid black",
          }}
        >
          <FaInfoCircle aria-hidden="true" />
          Infos
        </button>
        <button
          type="button"
          onClick={onSave}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 12px",
            border: "1px solid black",
          }}
        >
          <MdSave aria-hidden="true" />
          Share {!isMobile && " your design"}
        </button>
        <button
          type="button"
          onClick={onTutorial}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 12px",
            border: "1px solid black",
          }}
        >
          <FaVideo aria-hidden="true" />
          Tutorial
        </button>
        <button
          type="button"
          onClick={onSaveDesign}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 12px",
            border: "1px solid black",
          }}
        >
          <IoIosSave aria-hidden="true" />
          Save Design
        </button>
        {/* Duplicate button in toolbar - opens design section after duplication */}
        <button
          type="button"
          onClick={onAddProduct}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "8px 12px",
            border: "1px solid black",
          }}
        >
          <IoIosSave aria-hidden="true" />
          Duplicate
        </button>
      </div>
      <div className="threed-toolbar__promo" />
    </div>
  );
};

const DesignAssuranceBanner = ({ onClose }) => (
  <div className="threed-assurance">
    <div className="threed-assurance__content">
      <MdVerified size={20} color="#0a0a0f" aria-hidden="true" />
      <p>
        <strong>Design-Check:&nbsp;</strong>
        Our graphic designers check every design!
        <br />
        If we have any questions or comments, we'll get back to you in time.
      </p>
    </div>
    <button
      type="button"
      className="threed-assurance__close"
      onClick={onClose}
      aria-label="Dismiss design assurance"
    >
      ×
    </button>
  </div>
);

const InfoModal = ({ onClose }) => (
  <div className="threed-modal-backdrop" role="presentation" onClick={onClose}>
    <div
      className="threed-modal"
      role="dialog"
      aria-modal="true"
      aria-label="About this product"
      onClick={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        className="threed-modal__close"
        onClick={onClose}
        aria-label="Close info modal"
      >
        ×
      </button>
      <div className="threed-modal__body">
        <h2>About this product</h2>
        <div className="threed-modal__grid">
          <div className="threed-modal__image">
            <img src="/asset/img/productss.png" alt="Product preview" />
          </div>
          <div className="threed-modal__details">
            <h3>Game-Time Ready: Official Cricket Jersey</h3>
            <p className="threed-modal__price">
              $23/- &nbsp; $49/- &nbsp; you save $26/-
            </p>
            <p className="threed-modal__description">
              Colours and colour combinations — take control of your football
              shirt design with our wide selection! Choose from a curated
              palette of 48 stunning standard colours, each paired with its
              corresponding Pantone Matching System (PMS) number for precision.
              Whether you&rsquo;re matching your team&rsquo;s exact shade or
              creating something unique, we&rsquo;ve got you covered.
              <br />
              <br />
              Don&rsquo;t see the colour you had in mind? Reach out to us by
              email, and we&rsquo;ll bring your custom colour vision to life.
              Your design, your colour. Let&rsquo;s make it happen! Perfect for
              bulk order football jerseys, custom football T-shirts, and sports
              clothing worldwide.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const VideoModal = ({ onClose }) => (
  <div className="threed-modal-backdrop" role="presentation" onClick={onClose}>
    <div
      className="threed-modal threed-modal--narrow"
      role="dialog"
      aria-modal="true"
      aria-label="Configurator tutorial"
      onClick={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        className="threed-modal__close"
        onClick={onClose}
        aria-label="Close tutorial modal"
      >
        ×
      </button>
      <div className="threed-modal__body">
        <h2>Step-by-step through the configurator</h2>
        <img
          className="threed-video-modal__image"
          src="/asset/img/modalss.png"
          alt="Configurator tutorial"
        />
      </div>
    </div>
  </div>
);

const SaveModal = ({ onClose, onConfirm, loading }) => (
  <div className="threed-modal-backdrop" role="presentation" onClick={onClose}>
    <div
      className="threed-modal"
      role="dialog"
      aria-modal="true"
      aria-label="Save Design"
      onClick={(event) => event.stopPropagation()}
      style={{ width: "400px" }}
    >
      <button
        type="button"
        className="threed-modal__close"
        onClick={onClose}
        aria-label="Close save modal"
      >
        ×
      </button>
      <div className="threed-modal__body">
        <h2>Save Design</h2>
        <p>Are you sure you want to save this design?</p>
        <div className="modal-buttons" style={{ marginTop: "20px" }}>
          <button className="ok-button" onClick={onConfirm} disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
          <button
            className="cancel-button"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
);

const ThreeD = () => {
  const location = useLocation();
  const snap = useSnapshot(state);
  const navigate = useNavigate();
  const defaultMenuSlug = "men";
  const defaultSubcategorySlug = "men-jersey";

  // ==================== UNDO/REDO STATES ====================
  const [historyManagers, setHistoryManagers] = useState({});
  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);
  
  const modifiedGLB = useSelector((state) => state.cart.modifiedGLB);
  const { tokenDetails } = useSelector((state) => state.user);
  const { glbId } = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  const stateMenuSlug = location.state?.menuSlug;
  const stateSubcategorySlug = location.state?.subcategorySlug;
  const stateGlbFile = location.state?.glbFile;
  const stateSubcategoryId = location.state?.subcategoryId;
  const draftData = location.state?.draftData;
  const restoreData = location.state?.restoreData;

  const [menuSlug, setMenuSlug] = useState(stateMenuSlug || defaultMenuSlug);
  const [subcategorySlug, setSubcategorySlug] = useState(
    stateSubcategorySlug || defaultSubcategorySlug
  );
  const [loadedGlbFile, setLoadedGlbFile] = useState(
    () => enhanceGlbPayload(stateGlbFile) || null
  );
  const [isLoading, setIsLoading] = useState(() => !stateGlbFile);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 567);
  const [popupModal, setPopupModal] = useState(true);
  const [infoModal, setInfoModal] = useState(false);
  const [vdoModal, setVdoModal] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const [isRestoringDraft, setIsRestoringDraft] = useState(false);
  const [isEditingDraft, setIsEditingDraft] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [activeSubSection, setActiveSubSection] = useState(null);

  // ==================== UNDO/REDO FUNCTIONS ====================
  
  // Update undo/redo button status
  const updateUndoRedoStatus = useCallback((productId) => {
    if (!productId || !historyManagers[productId]) {
      setCanUndo(false);
      setCanRedo(false);
      return;
    }
    
    const status = historyManagers[productId].getStatus();
    setCanUndo(status.canUndo);
    setCanRedo(status.canRedo);
  }, [historyManagers]);

// Handle undo - fixed
const handleUndo = useCallback(() => {
  const productId = snap.currentProductId;
  if (!productId || !historyManagers[productId]) {
    toast.error("Cannot undo: History not available");
    return;
  }
  
  const manager = historyManagers[productId];
  if (!manager.canUndo()) {
    toast.info("Nothing to undo");
    return;
  }
  
  const previousState = manager.undo();
  if (previousState) {
    const currentProduct = state.products[productId];
    if (!currentProduct) {
      toast.error("Cannot undo: Product not found");
      return;
    }
    
    // Apply the complete snapshot
    manager.applySnapshot(previousState, currentProduct, state);
    
    updateUndoRedoStatus(productId);
    toast.success("Undo applied");
  }
}, [snap.currentProductId, historyManagers, updateUndoRedoStatus]);

// Handle redo - fixed
const handleRedo = useCallback(() => {
  const productId = snap.currentProductId;
  if (!productId || !historyManagers[productId]) {
    toast.error("Cannot redo: History not available");
    return;
  }
  
  const manager = historyManagers[productId];
  if (!manager.canRedo()) {
    toast.info("Nothing to redo");
    return;
  }
  
  const nextState = manager.redo();
  if (nextState) {
    const currentProduct = state.products[productId];
    
    if (!currentProduct) {
      toast.error("Cannot redo: Product not found");
      return;
    }
    
    // Apply the complete snapshot
    manager.applySnapshot(nextState, currentProduct, state);
    
    updateUndoRedoStatus(productId);
    toast.success("Redo applied");
  }
}, [snap.currentProductId, historyManagers, updateUndoRedoStatus]);

  // Fix handleCustomizationChange
  const handleCustomizationChange = useCallback((type, value) => {
    const productId = snap.currentProductId;
    if (!productId || !historyManagers[productId]) {
      console.log("No history manager for customization change");
      return;
    }
    
    // Save to history immediately when customization changes
    const currentProduct = state.products[productId];
    if (currentProduct) {
      historyManagers[productId].push(currentProduct, 100); // Quicker debounce for manual changes
      updateUndoRedoStatus(productId);
    }
  }, [snap.currentProductId, historyManagers, updateUndoRedoStatus]);

  // Initialize or update history manager when product changes
  useEffect(() => {
    const productId = snap.currentProductId;
    if (!productId) return;
    
    const currentProduct = state.products[productId];
    if (!currentProduct) return;
    
    // Initialize history manager if needed
    if (!historyManagers[productId]) {
      console.log("Setting up history manager for:", productId);
      const newManager = new HistoryManager(productId);
      
      // Set the manager first
      setHistoryManagers(prev => ({
        ...prev,
        [productId]: newManager
      }));
      
      // Save initial state after a short delay to ensure manager is set
      setTimeout(() => {
        setHistoryManagers(prev => {
          const manager = prev[productId];
          if (manager && currentProduct) {
            const currentProduct = state.products[productId];
            if (currentProduct) {
              manager.push(currentProduct, 0);
            }
          }
          return prev;
        });
        
        updateUndoRedoStatus(productId);
      }, 50);
    }
  }, [snap.currentProductId, historyManagers, updateUndoRedoStatus]);

  // Monitor state changes and save to history
  useEffect(() => {
    const productId = snap.currentProductId;
    if (!productId || !historyManagers[productId]) return;
    
    const currentProduct = state.products[productId];
    if (!currentProduct) return;
    
    const manager = historyManagers[productId];
    const lastState = manager.history[manager.currentIndex];
    
    if (!lastState) {
      // No previous state, save current one (initial state)
      if (manager.history.length === 0) {
        manager.push(currentProduct, 0);
        updateUndoRedoStatus(productId);
      }
      return;
    }
    
    // Create comparison objects
    const currentSnapshot = {
      partColors: currentProduct.partColors,
      textColors: currentProduct.textColors,
      numberColors: currentProduct.numberColors,
      gradientColors: currentProduct.gradientColors,
      patternColors: currentProduct.patternColors,
      imagesPattern: currentProduct.imagesPattern,
      selectedPattern: currentProduct.selectedPattern,
      frontText: currentProduct.frontText,
      backText: currentProduct.backText,
      frontNumber: currentProduct.frontNumber,
      backNumber: currentProduct.backNumber,
      frontLogo: currentProduct.frontLogo,
      backLogo: currentProduct.backLogo,
      textFonts: currentProduct.textFonts,
      numberFonts: currentProduct.numberFonts,
      selectedFonts: currentProduct.selectedFonts
    };
    
    const lastSnapshot = {
      partColors: lastState.partColors,
      textColors: lastState.textColors,
      numberColors: lastState.numberColors,
      gradientColors: lastState.gradientColors,
      patternColors: lastState.patternColors,
      imagesPattern: lastState.imagesPattern,
      selectedPattern: lastState.selectedPattern,
      frontText: lastState.frontText,
      backText: lastState.backText,
      frontNumber: lastState.frontNumber,
      backNumber: lastState.backNumber,
      frontLogo: lastState.frontLogo,
      backLogo: lastState.backLogo,
      textFonts: lastState.textFonts,
      numberFonts: lastState.numberFonts,
      selectedFonts: lastState.selectedFonts
    };
    
    // Compare JSON strings
    if (JSON.stringify(currentSnapshot) !== JSON.stringify(lastSnapshot)) {
      manager.push(currentProduct, 300); // 300ms debounce
      updateUndoRedoStatus(productId);
    }
  }, [
    snap.currentProductId,
    snap.products[snap.currentProductId]?.partColors,
    snap.products[snap.currentProductId]?.textColors,
    snap.products[snap.currentProductId]?.numberColors,
    snap.products[snap.currentProductId]?.gradientColors,
    snap.products[snap.currentProductId]?.patternColors,
    snap.products[snap.currentProductId]?.imagesPattern,
    snap.products[snap.currentProductId]?.selectedPattern,
    snap.products[snap.currentProductId]?.frontText,
    snap.products[snap.currentProductId]?.backText,
    snap.products[snap.currentProductId]?.frontNumber,
    snap.products[snap.currentProductId]?.backNumber,
    snap.products[snap.currentProductId]?.frontLogo,
    snap.products[snap.currentProductId]?.backLogo,
    snap.products[snap.currentProductId]?.textFonts,
    snap.products[snap.currentProductId]?.numberFonts,
    snap.products[snap.currentProductId]?.selectedFonts,
    historyManagers,
    updateUndoRedoStatus
  ]);

  // Keyboard shortcuts for undo/redo
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ctrl+Z for undo
      if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        if (canUndo) handleUndo();
      }
      // Ctrl+Y or Ctrl+Shift+Z for redo
      if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) {
        e.preventDefault();
        if (canRedo) handleRedo();
      }
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [canUndo, canRedo, handleUndo, handleRedo]);

  // Add cleanup effect for debounce timers
  useEffect(() => {
    return () => {
      // Clean up any pending debounce timers when component unmounts
      Object.values(historyManagers).forEach(manager => {
        if (manager && manager.debounceTimer) {
          clearTimeout(manager.debounceTimer);
        }
      });
    };
  }, [historyManagers]);

  // ==================== REST OF YOUR EXISTING CODE ====================
  
  const handleProductSelect = useCallback((productId) => {
    state.currentProductId = productId;
  }, []);
  
  const handleDeleteProduct = useCallback((productId) => {
    deleteProduct(productId, state, snap);
    
    // Clean up history for deleted product
    setHistoryManagers(prev => {
      const newManagers = { ...prev };
      delete newManagers[productId];
      return newManagers;
    });
  }, [snap]);
  
  const openDesignSection = useCallback(() => {
    setActiveSection("design");
    setActiveSubSection("category");
    
    if (window.innerWidth < 567) {
      const customizerElement = document.querySelector('.threed-customizer');
      if (customizerElement) {
        customizerElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);
  
  const restoreDraftSettings = useCallback(
    (draftData) => {
      try {
        setIsRestoringDraft(true);

        const settings =
          typeof draftData.settings === "string"
            ? JSON.parse(draftData.settings)
            : draftData.settings;

        console.log("Parsed settings for restoration:", settings);

        const currentProduct = state.products[state.currentProductId];
        
        if (!currentProduct) {
          console.error("No current product found for restoration");
          return;
        }

        // Restore all state values to current product
        if (settings.frontText) currentProduct.frontText = settings.frontText;
        if (settings.backText) currentProduct.backText = settings.backText;
        if (settings.frontNumber) currentProduct.frontNumber = settings.frontNumber;
        if (settings.backNumber) currentProduct.backNumber = settings.backNumber;

        if (settings.Colors) {
          currentProduct.partColors = settings.Colors;
        }

        if (settings.textColors) {
          currentProduct.textColors = settings.textColors;
        }

        if (settings.numberColors) {
          currentProduct.numberColors = settings.numberColors;
        }

        if (settings.gradientColors) {
          currentProduct.gradientColors = settings.gradientColors;
        }

        if (settings.textFonts) {
          currentProduct.textFonts = settings.textFonts;
        }

        if (settings.numberFonts) {
          currentProduct.numberFonts = settings.numberFonts;
        }

        if (settings.imagesPattern) {
          currentProduct.imagesPattern = settings.imagesPattern;
        }

        if (settings.patternColors) {
          currentProduct.patternColors = settings.patternColors;
        }

        if (settings.selectedFonts) {
          currentProduct.selectedFonts = settings.selectedFonts;
        }

        if (settings.selectedPattern) {
          currentProduct.selectedPattern = settings.selectedPattern;
        }

        if (menuSlug && subcategorySlug) {
          const key = `${menuSlug}${subcategorySlug}`.replace(/-/g, "");
          if (modelConfig1[key]) {
            currentProduct.newKey = key;
          }
        }

        state.updateTrigger = (state.updateTrigger || 0) + 1;

        console.log("Draft restoration complete");

        // Save to history after restoration
        setTimeout(() => {
          const productId = state.currentProductId;
          if (productId && historyManagers[productId]) {
            historyManagers[productId].push(currentProduct, 0);
            updateUndoRedoStatus(productId);
          }
          setIsRestoringDraft(false);
        }, 500);
      } catch (error) {
        console.error("Error restoring draft:", error);
        setIsRestoringDraft(false);
      }
    },
    [menuSlug, subcategorySlug, historyManagers, updateUndoRedoStatus]
  );

  useEffect(() => {
    if (restoreData?.settings) {
      console.log("Restoring draft data:", restoreData);
      setIsEditingDraft(true);
      restoreDraftSettings(restoreData);
    }
  }, [restoreData]);

  useEffect(() => {
    if (stateMenuSlug && stateMenuSlug !== menuSlug) {
      setMenuSlug(stateMenuSlug);
    }
  }, [stateMenuSlug, menuSlug]);

  useEffect(() => {
    if (stateSubcategorySlug && stateSubcategorySlug !== subcategorySlug) {
      setSubcategorySlug(stateSubcategorySlug);
    }
  }, [stateSubcategorySlug, subcategorySlug]);

  useEffect(() => {
    if (!stateGlbFile) {
      return;
    }
    setLoadedGlbFile(enhanceGlbPayload(stateGlbFile));
    setIsLoading(false);
  }, [stateGlbFile]);

  useEffect(() => {
    let isMounted = true;

    const fetchGlb = async () => {
      if (loadedGlbFile) {
        return;
      }

      setIsLoading(true);

      try {
        const formData = new FormData();
        formData.append("subcategoryId", stateSubcategoryId || 22);

        const result = await get_glbFile(formData);

        if (!isMounted) {
          return;
        }

        if (
          !result?.success ||
          !Array.isArray(result?.data) ||
          result.data.length === 0
        ) {
          toast.error("Failed to fetch 3D model. Please try again.");
          setLoadedGlbFile(null);
          return;
        }

        setLoadedGlbFile(enhanceGlbPayload(result.data));
      } catch (error) {
        if (!isMounted) {
          return;
        }
        console.error("Error fetching GLB:", error);
        toast.error("Something went wrong while loading the 3D model.");
        setLoadedGlbFile(null);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchGlb();

    return () => {
      isMounted = false;
    };
  }, [loadedGlbFile, stateSubcategoryId]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 567);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleRetryFetch = useCallback(() => {
    setLoadedGlbFile(null);
    setIsLoading(false);
  }, []);

  const handleInfoClick = useCallback(() => {
    setInfoModal(true);
    setVdoModal(false);
  }, []);

  const handleSaveClick = useCallback(() => {
    downloadCanvasToImage();
  }, []);

  const handleTutorialClick = useCallback(() => {
    setVdoModal(true);
    setInfoModal(false);
  }, []);

  const handleSaveDesignClick = useCallback(() => {
    if (!tokenDetails) {
      toast.error("Please login or Signup to save designs");
      return;
    }
    setSaveModal(true);
  }, [tokenDetails]);

  
const confirmSaveDesign = useCallback(async () => {
  try {
    setSaveLoading(true);

    // Get current product from state
    const currentProduct = snap.products[snap.currentProductId];
    
    if (!currentProduct) {
      toast.error("No active product found");
      setSaveLoading(false);
      return;
    }

    // DEBUG: Log critical values
    console.log("Debug - glbId:", glbId);
    console.log("Debug - currentProduct:", currentProduct);
    console.log("Debug - tokenDetails:", tokenDetails);
    console.log("Debug - menuSlug:", menuSlug);
    console.log("Debug - subcategorySlug:", subcategorySlug);

    // Check if glbId exists
    if (!glbId) {
      toast.error("Product GLB ID is missing. Please try reloading the page.");
      setSaveLoading(false);
      return;
    }

    // Get PNG snapshot - handle cases where canvas might not be ready
    const canvas = document.querySelector("canvas");
    if (!canvas) {
      console.warn("Canvas not found, using fallback");
      // Continue without image or use a placeholder
    }

    let pngDataUrl = "";
    try {
      pngDataUrl = canvas ? canvas.toDataURL("image/png") : "";
    } catch (canvasError) {
      console.warn("Could not get canvas data:", canvasError);
      pngDataUrl = "";
    }

    // Get model settings
    const newKey = currentProduct.newKey;
    const imagesPattern = currentProduct.imagesPattern || {};
    const modelSettings = modelConfig1[newKey] || {};

    // Prepare settings with null/undefined checks
    let updatedSettings = {
      frontText: currentProduct.frontText || '',
      backText: currentProduct.backText || '',
      frontNumber: currentProduct.frontNumber || '',
      backNumber: currentProduct.backNumber || '',
      frontLogo: currentProduct.frontLogo || null,
      backLogo: currentProduct.backLogo || null,
      Colors: currentProduct.partColors || {},
      textFonts: currentProduct.textFonts || {},
      numberFonts: currentProduct.numberFonts || {},
      textColors: currentProduct.textColors || {},
      numberColors: currentProduct.numberColors || {},
      gradientColors: currentProduct.gradientColors || {},
      imagesPattern: imagesPattern,
      patternColors: currentProduct.patternColors || {},
      selectedFonts: currentProduct.selectedFonts || "Arial",
      selectedPattern: currentProduct.selectedPattern || {},
    };

    // If we have model settings, merge them
    if (modelSettings && Object.keys(modelSettings).length > 0) {
      updatedSettings = {
        ...modelSettings,
        ...updatedSettings
      };
    }

    console.log("Debug - Updated settings:", updatedSettings);

    // Convert pattern images to files - only if they exist
    const imageArray = [];
    if (imagesPattern && typeof imagesPattern === 'object') {
      Object.entries(imagesPattern).forEach(([position, pattern]) => {
        if (pattern && pattern.image && typeof pattern.image === 'string' && pattern.image.includes('base64')) {
          try {
            const base64 = pattern.image;
            const byteString = atob(base64.split(",")[1]);
            const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];

            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }

            const blob = new Blob([ab], { type: mimeString });
            const file = new File([blob], `${position}_pattern.png`, {
              type: mimeString,
            });

            imageArray.push({ position, file });
          } catch (imageError) {
            console.warn(`Failed to process pattern for ${position}:`, imageError);
          }
        }
      });
    }

    const formData = new FormData();

    // Prepare cart data
    const cartData = {
      glb: [{
        glb_id: glbId,  // This must exist
        settings: updatedSettings,
        size_id: 1,
        image: pngDataUrl,
        menuSlug: menuSlug,
        subcategorySlug: subcategorySlug,
        productId: snap.currentProductId,
      }]
    };

    console.log("Debug - Cart data being sent:", cartData);

    formData.append("cart", JSON.stringify(cartData));

    // Append cart data
    const cartDataForImages = imageArray.map(({ position }) => ({ position }));
    formData.append("cartData", JSON.stringify(cartDataForImages));
    
    // Append image files
    imageArray.forEach(({ file }, index) => {
      formData.append(`cartImage[${index}]`, file);
    });

    // Log FormData contents for debugging
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    // Call save API
    console.log("Debug - Calling saveDesign API...");
    const response = await saveDesign(formData, tokenDetails);
    
    console.log("Debug - API Response:", response);

    if (response?.data?.success) {
      toast.success(response.data.message || "Design saved successfully!");
      setSaveModal(false);
      navigate("/profile");
    } else {
      // Check for different error formats
      const errorMessage = response?.data?.message || 
                          response?.message || 
                          response?.error || 
                          "Failed to save design";
      toast.error(errorMessage);
    }
  } catch (error) {
    console.error("Save design error details:", error);
    
    // More specific error messages
    if (error.response) {
      // Server responded with error status
      console.error("Server error:", error.response.data);
      toast.error(error.response.data.message || "Server error occurred");
    } else if (error.request) {
      // Request was made but no response
      toast.error("No response from server. Please check your connection.");
    } else {
      // Something else happened
      toast.error(error.message || "An unexpected error occurred");
    }
  } finally {
    setSaveLoading(false);
  }
}, [tokenDetails, glbId, menuSlug, subcategorySlug, snap, navigate]);

const duplicateCurrentProduct = useCallback(() => {
  const currentProductId = snap.currentProductId || 'product1';
  const productIds = Object.keys(snap.products || {});
  const lastId = productIds.length > 0
    ? Math.max(...productIds.map((id) => parseInt(id.replace("product", ""))))
    : 0;
  const newProductId = `product${lastId + 1}`;
  
  const sourceProduct = snap.products[currentProductId];
  
  if (sourceProduct) {
    // Create a proper deep clone function
    const deepCloneProduct = (product) => {
      try {
        // Extract data from proxy
        const productData = JSON.parse(JSON.stringify(product));
        
        // Ensure imagesPattern is properly cloned
        if (productData.imagesPattern) {
          Object.keys(productData.imagesPattern).forEach(key => {
            if (productData.imagesPattern[key]?.image) {
              productData.imagesPattern[key] = {
                ...productData.imagesPattern[key],
                image: String(productData.imagesPattern[key].image)
              };
            }
          });
        }
        
        // Ensure modelName is properly cloned
        if (productData.modelName) {
          productData.modelName = String(productData.modelName);
        }
        
        return productData;
      } catch (error) {
        console.error("Error cloning product:", error);
        return {
          id: lastId + 1,
          frontText: '',
          backText: '',
          frontNumber: '',
          backNumber: '',
          frontLogo: null,
          backLogo: null,
          partColors: {},
          textColors: {},
          numberColors: {},
          gradientColors: {},
          textFonts: {},
          numberFonts: {},
          imagesPattern: {},
          patternColors: {},
          selectedFonts: "Arial",
          selectedPattern: {},
          svg: product?.svg || null,
          modelName: product?.modelName || '', // Keep the model name
          viewSide: product?.viewSide || "front",
          isActive: true,
          // Add unique material state for each product
          materialState: {
            texturesLoaded: false,
            materialsApplied: false,
            lastModelUrl: product?.modelName || null
          }
        };
      }
    };
    
    const clonedProduct = deepCloneProduct(sourceProduct);
    clonedProduct.id = lastId + 1;
    clonedProduct.isActive = true;
    
    // CRITICAL: Add unique material state for each product
    clonedProduct.materialState = {
      texturesLoaded: false,
      materialsApplied: false,
      lastModelUrl: sourceProduct.modelName || null
    };
    
    state.products[newProductId] = clonedProduct;
    
    // Deactivate previous product
    if (state.products[currentProductId]) {
      state.products[currentProductId].isActive = false;
    }
    
    // Switch to new product
    state.currentProductId = newProductId;
    
    // Initialize history for the new product
    setTimeout(() => {
      const newManager = new HistoryManager(newProductId);
      setHistoryManagers(prev => ({
        ...prev,
        [newProductId]: newManager
      }));
      
      // Save initial state
      setTimeout(() => {
        newManager.push(clonedProduct, 0);
        updateUndoRedoStatus(newProductId);
      }, 50);
    }, 100);
    
    // IMPORTANT: Force a complete model refresh for the new product
    setTimeout(() => {
      // Clear any cached model data
      if (clonedProduct.materialState) {
        clonedProduct.materialState.texturesLoaded = false;
        clonedProduct.materialState.materialsApplied = false;
      }
      
      // Force a state update to trigger model reload
      state.updateTrigger = (state.updateTrigger || 0) + 1;
    }, 150);
    
    toast.success(`Product ${lastId + 1} created with same customizations!`);
    
    return newProductId;
  } else {
    toast.error("Failed to duplicate product");
    return null;
  }
}, [snap.products, snap.currentProductId, state, updateUndoRedoStatus]);

  // Add this useEffect to trigger 3D model updates
useEffect(() => {
  const productId = snap.currentProductId;
  if (!productId) return;
  
  const currentProduct = state.products[productId];
  if (!currentProduct) return;
  
  // This will trigger a re-render of the Canva component
  // Force a small state update to trigger 3D model refresh
  const timer = setTimeout(() => {
    state.updateTrigger = (state.updateTrigger || 0) + 1;
  }, 100);
  
  return () => clearTimeout(timer);
}, [snap.currentProductId, snap.products[snap.currentProductId]?.imagesPattern]);
const duplicateCurrentProduct1 = useCallback(() => {
  const currentProductId = snap.currentProductId || 'product1';
  const productIds = Object.keys(snap.products || {});
  const lastId = productIds.length > 0
    ? Math.max(...productIds.map((id) => parseInt(id.replace("product", ""))))
    : 0;
  const newProductId = `product${lastId + 1}`;
  
  const sourceProduct = snap.products[currentProductId];
  
  if (sourceProduct) {
    // Create a proper deep clone function for this specific case
    const deepCloneProduct = (product) => {
      try {
        // Extract data from proxy
        const productData = JSON.parse(JSON.stringify(product));
        
        // Ensure imagesPattern is properly cloned
        if (productData.imagesPattern) {
          Object.keys(productData.imagesPattern).forEach(key => {
            if (productData.imagesPattern[key]?.image) {
              // Create a fresh copy of the image data
              productData.imagesPattern[key] = {
                ...productData.imagesPattern[key],
                image: String(productData.imagesPattern[key].image)
              };
            }
          });
        }
        
        return productData;
      } catch (error) {
        console.error("Error cloning product:", error);
        return {
          id: lastId + 1,
          frontText: '',
          backText: '',
          frontNumber: '',
          backNumber: '',
          frontLogo: null,
          backLogo: null,
          partColors: {},
          textColors: {},
          numberColors: {},
          gradientColors: {},
          textFonts: {},
          numberFonts: {},
          imagesPattern: {},
          patternColors: {},
          selectedFonts: "Arial",
          selectedPattern: {},
          svg: null,
          modelName: '',
          viewSide: "front",
          isActive: true,
        };
      }
    };
    
    const clonedProduct = deepCloneProduct(sourceProduct);
    clonedProduct.id = lastId + 1;
    clonedProduct.isActive = true;
    
    state.products[newProductId] = clonedProduct;
    state.currentProductId = newProductId;
    
    // Deactivate previous product
    state.products[currentProductId].isActive = false;
    
    // Initialize history for the new product
    setTimeout(() => {
      const newManager = new HistoryManager(newProductId);
      setHistoryManagers(prev => ({
        ...prev,
        [newProductId]: newManager
      }));
      
      // Save initial state
      setTimeout(() => {
        newManager.push(clonedProduct, 0);
        updateUndoRedoStatus(newProductId);
      }, 50);
    }, 100);
    
    toast.success(`Product ${lastId + 1} created with same customizations!`);
    state.updateTrigger = (state.updateTrigger || 0) + 1;
  } else {
    toast.error("Failed to duplicate product");
  }
}, [snap.products, snap.currentProductId, state, updateUndoRedoStatus]);
  
const handleAddProduct = useCallback(() => {
  duplicateCurrentProduct();
}, [duplicateCurrentProduct]);

const handleDuplicateAndDesign = useCallback(() => {
  const newProductId = duplicateCurrentProduct();
  if (newProductId) {
    openDesignSection();
  }
}, [duplicateCurrentProduct, openDesignSection]);
  
  const normalizedGlbFile = useMemo(
    () => (Array.isArray(loadedGlbFile) ? loadedGlbFile : []),
    [loadedGlbFile]
  );

  if (isLoading) {
    return <ThreeDSkeleton />;
  }

  const hasGlbData = normalizedGlbFile.length > 0;

  if (!hasGlbData) {
    return <EmptyState onRetry={handleRetryFetch} />;
  }

  return (
    <div className="threed-page">
      <div className="threed-customizer">
        <Customizer 
          glbFile={normalizedGlbFile}  
          activeSection={activeSection}
          activeSubSection={activeSubSection}
          onSectionClose={() => {
            setActiveSection(null);
            setActiveSubSection(null);
          }}
          onCustomizationChange={handleCustomizationChange}
        />
      </div>
      <div className="threed-canvas">
        <Canva
          menuSlug={menuSlug}
          subcategorySlug={subcategorySlug}
          isEditingDraft={isEditingDraft}
        />
      </div>

      <BottomToolbar
        onInfo={handleInfoClick}
        onSave={handleSaveClick}
        onTutorial={handleTutorialClick}
        onSaveDesign={handleSaveDesignClick}
        onDuplicate={handleDuplicateAndDesign}
        onAddProduct={handleAddProduct}
        products={snap.products}
        currentProductId={snap.currentProductId}
        onProductSelect={handleProductSelect}
        onDeleteProduct={handleDeleteProduct}
        onUndo={handleUndo}
        onRedo={handleRedo}
        canUndo={canUndo}
        canRedo={canRedo}
      />

      {!isMobile && popupModal && (
        <DesignAssuranceBanner onClose={() => setPopupModal(false)} />
      )}

      {infoModal && !vdoModal && (
        <InfoModal onClose={() => setInfoModal(false)} />
      )}

      {vdoModal && <VideoModal onClose={() => setVdoModal(false)} />}

      {saveModal && (
        <SaveModal
          onClose={() => setSaveModal(false)}
          onConfirm={confirmSaveDesign}
          loading={saveLoading}
        />
      )}
    </div>
  );
};

export default ThreeD;